import { connect } from 'react-redux';
import React from 'react';
import { Tiles } from 'wsm-tiles';
import {
	useLabels,
	useSitemap,
	usePrefs,
	useRequestData
} from 'wsm-common-data';
import { setClassNames } from '@ddc/classnames-js';
import { usePostalCode } from '../hooks/usePostalCode';
import { useFetchLocations } from '../hooks/useFetchLocations';
import { buildLocationTiles } from '../utils/buildLocationTiles';

const WidgetContainer = () => {
	const labels = useLabels();
	const sitemap = useSitemap();
	const { deviceType } = useRequestData();
	const rawLDPUrl = sitemap.get('LOCATION_DETAILS');
	// delete last 4 characters (i.e., remove ".htm")
	const ldpPart = (rawLDPUrl || '').slice(0, -4);
	const postalCode = usePostalCode();
	const state = useFetchLocations(postalCode);
	const { showAddress, widgetHeading } = usePrefs();
	const isDesktop = deviceType !== 'MOBILE';

	if (state.isLoading) {
		return <div>Loading...</div>;
	}
	if (state.error) {
		return <div>Error: something went wrong</div>;
	}

	const tileData = buildLocationTiles(
		state.data,
		ldpPart,
		showAddress === 'true'
	);

	const titleClasses = setClassNames([
		'text-center',
		isDesktop ? 'my-3' : 'my-3 pl-6'
	]);

	const tilesClasses = setClassNames([
		'my-5',
		isDesktop ? 'justify-content-center' : 'px-6 overflow-auto'
	]);

	return (
		<section>
			<h2 className={titleClasses}>{labels.get(widgetHeading)}</h2>
			<Tiles
				type="location"
				data={tileData}
				layout={isDesktop ? 'grid' : 'carousel'}
				className={tilesClasses}
			/>
		</section>
	);
};

WidgetContainer.propTypes = {};

const mapStateToProps = (_state) => {
	return {};
};

const mapDispatchToProps = (_dispatch) => ({});

const Widget = connect(mapStateToProps, mapDispatchToProps)(WidgetContainer);

export default Widget;
